import useGetLocation from './useGetLocation'

const useIsUSCountry = () => {
  const country = useGetLocation()
  return country == 'US' ? true : false
}
export default useIsUSCountry
